export const config = [
  {
    section: "Patient Rights",
    list: [
      "The patient has the right to considerate and respectful service.",
      "The patient has the right to obtain service without regard to race, creed, national origin, sex, age, disability, diagnosis or religious affiliation.",
      "Subject to applicable law, the patient has the right to confidentiality of all information pertaining to his/her medical equipment service. Individuals or organizations not involved in the patient's care, may not have access to the information without the patient's written consent.",
      "The patient has the right to make informed decisions about his/her care.",
      "The patient has the right to reasonable continuity of care and service.",
      "The patient has the right to voice grievances without fear of termination of service or other reprisal in the service process.",
    ],
  },
  {
    section: "Patient Responsibilities",
    list: [
      "The patient should promptly notify the Home Medical Equipment Company of any equipment failure or damage.",
      "The patient is responsible for any equipment that is lost or stolen while in their possession and should promptly notify the Home Medical Equipment Company in such instances.",
      "The patient should promptly notify the Home Medical Equipment Company of any changes to their address or telephone.",
      "The patient should promptly notify the Home Medical Equipment Company of any changes concerning their physician.",
      "The patient should notify the Home Medical Equipment Company of discontinuance of use.",
      "Except where contrary to federal or state law, the patient is responsible for any equipment rental and sale charges which the patient's insurance company/companies does not pay.",
    ],
  },
  {
    section: "Warranty",
    description: [
      "Every product sold by our company carries a warranty. We notify all Medicare beneficiaries/customers of the warranty coverage, and we will honor all warranties under applicable law. We will repair or replace, free of charge, Medicare-covered equipment that is under warranty. In addition, an owner's manual with warranty information will be provided to beneficiaries for all durable medical equipment where this manual is available.",
    ],
  },
  {
    section: "Medicare DMEPOS Supplier Standards (30) Statement",
    description: [
      "The products and/or services provided to you by your supplier are subject to the supplier standards contained in the Federal regulations shown at 42 Code of Federal Regulations Section 424.57 (c). These standards concern business professional and operational matters (e.g., honoring warranties, hours of operation). The full text of these standards can be obtained from cms.gov.",
    ],
  },
  {
    section: "Text Message (SMS) Communications",
    description: [
      "With your consent, we may contact you by text message (SMS) for purposes such as prescription refill reminders, reminders, and other communications related to your care.",
      "You may opt out of text messages at any time by replying STOP to any message. Message and data rates may apply.",
      "Your mobile phone number, SMS consent, and opt-in information will not be shared with or sold to third parties or affiliates for marketing or promotional purposes.",
    ],
  },
];
